import React, { useContext } from "react";
import { Box, ListItem, ListItemText } from "@mui/material";
import { getColors } from "../../themes/theme";
import { ThemeContext } from "../../context/ThemeContext";

export const MainList = ({ mainItems, selectedMainId, onMainSelect }) => {
  const { darkMode } = useContext(ThemeContext);

  return (
    <Box
      sx={{
        width: "200px",
        pr: "20px",
        borderRight: `1px solid ${
          darkMode ? getColors.appBarBorderDark : getColors.appBarBorderLight
        }`,
      }}
    >
      {mainItems?.map((mainItem) => (
        <ListItem
          key={mainItem.id}
          button
          onClick={() => onMainSelect(mainItem.id)}
          sx={{
            fontSize: "22px",
            px: "28px",
            py: "14px",
            mb: 1,
            background:
              selectedMainId === mainItem.id
                ? getColors.listItemHoverBg
                : "transparent",
            "&:hover": {
              background: getColors.listItemHoverBg,
            },
          }}
        >
          <ListItemText
            primary={mainItem.name}
            sx={{
              "& .MuiListItemText-primary": {
                color:
                  selectedMainId === mainItem.id
                    ? getColors.primaryTextDark
                    : darkMode
                    ? getColors.drawerTextDark
                    : getColors.thumbnailTextLight,
              },
            }}
          />
        </ListItem>
      ))}
    </Box>
  );
};
